import Collapse from './Collapse';

export default Collapse;



// WEBPACK FOOTER //
// ./src/collapse/index.js